import RodolpheData from "../components/RodolpheData";
import { Box, Typography, Button } from "@mui/material";


const Rodolphe = () => {
 
  return (
    <Box>
      <RodolpheData />
    </Box>
  );
};

export default Rodolphe;
